import { render, staticRenderFns } from "./IssuedTaskDetail.vue?vue&type=template&id=611a1f0e&scoped=true&"
import script from "./IssuedTaskDetail.vue?vue&type=script&lang=js&"
export * from "./IssuedTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./IssuedTaskDetail.vue?vue&type=style&index=0&id=611a1f0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a1f0e",
  null
  
)

export default component.exports